// iter 398 — effective roles = primary role + secondary roles.
// Brady is a technician with a 'dispatch' secondary role; anything that
// gated on localStorage.user_role alone hid the dispatcher pages from him.
const ALIASES = { dispatch: "dispatcher" };

export function getEffectiveRoles() {
  if (typeof localStorage === "undefined") return [];
  const primary = (localStorage.getItem("user_role") || "").toLowerCase();
  let secondary = [];
  try {
    secondary = JSON.parse(localStorage.getItem("user_secondary_roles") || "[]");
  } catch {
    secondary = [];
  }
  const all = [primary, ...secondary.map((r) => String(r || "").toLowerCase())].filter(Boolean);
  return [...new Set(all.map((r) => ALIASES[r] || r))];
}

export function hasAnyRole(allowed = []) {
  const mine = getEffectiveRoles();
  return allowed.some((r) => mine.includes(String(r).toLowerCase()));
}
